require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/analytics/legacy/perso/lvp-history.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/analytics/legacy/perso/lvp-history.legacy.js
// module id = 809
// module chunks = 31